import { put, takeLatest } from 'redux-saga/effects';
import QueryString from 'querystring';
import types from 'redux/types';
import Services from 'services';
import { isResponseSuccess } from 'helpers';
import { MANAGE_USERS_URL } from 'consts/api';
import Broadcast from 'services/BroadcastChannel';
import { showError } from 'helpers/handleError';
import UserServices from 'services/UserServices';

const {
  REQUEST_MANAGE_USER,
  REQUEST_MANAGE_USER_SUCCESS,
  REQUEST_MANAGE_USER_FAILED,
  REQUEST_CHANGE_USER,
} = types;

export function* getManageUser() {
  try {
    const res = yield Services.post(
      MANAGE_USERS_URL,
      QueryString.stringify({
        action: 'searchAll',
        pageSize: 0,
        page: 0,
      })
    );
    const { status, data } = res;
    if (isResponseSuccess(status)) {
      if (typeof data === 'string' && data.toLowerCase() === 'fail') {
        showError('Something went wrong! Please try again by refresh webpage!');
      } else {
        yield put({
          type: REQUEST_MANAGE_USER_SUCCESS,
          data,
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_MANAGE_USER_FAILED,
      error,
    });
  }
}

function* switchUser(data) {
  const { currentUser, targetUser } = data;

  try {
    const res = yield Services.post(
      MANAGE_USERS_URL,
      QueryString.stringify({
        action: 'loginasuser',
        username: targetUser,
      })
    );

    if (isResponseSuccess(res.status)) {
      const rootUser = UserServices.getRootUser();

      //* rootUser should be an Admin or Manager, system will store the first admin or manager
      if (!rootUser) {
        UserServices.setRootUser(currentUser);
      }

      Broadcast.channelSwitchUser().postMessageReload();
      window.location.href = '/';
    }
  } catch (error) {
    showError(error);
    yield put({
      type: REQUEST_MANAGE_USER_FAILED,
      errorSwitchUser: error,
    });
  }
}

export default function* watchAPIFunction() {
  yield takeLatest(REQUEST_MANAGE_USER, getManageUser);
  yield takeLatest(REQUEST_CHANGE_USER, switchUser);
}
